import React from 'react'
import { Link } from 'react-router-dom'

import { Grid, Typography } from '@mui/material'

const CardHeader = ({ icon = null, title = null, linkPath = null }) => {

    return (<Grid container maxWidth spacing={2} padding={2} alignItems='center'>
    <Grid container item xs={8} spacing={3} alignItems='center'>
        { icon && <Grid item xs={2}>{icon}</Grid> }
        { title && <Grid item xs={10}><Typography variant='h5'>{title}</Typography></Grid> }
    </Grid>
</Grid>)
}

export default CardHeader